import React, { useEffect, useCallback, useContext, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { axios, context as AuthContext } from '../../context/auth'

import FormError from '../../styled/form-error'
import InputGroup from '../../styled/input-group'
import AuthFormContainer from '../../styled/auth-form-container'
import { PrimaryButton } from '../../styled/button'

const ConfirmRegistrationSchema = Yup.object().shape({
  email: Yup.string().min(6).max(150).email().required()
})

const ConfirmRegistration = () => {
  const navigate = useNavigate()
  const { token } = useParams()
  const [confirmed, setConfirmed] = useState()
  const { refreshUser } = useContext(AuthContext)

  const { values, errors, touched, setErrors, setFieldValue, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: ConfirmRegistrationSchema,
    onSubmit: (formValues) => confirmRegistration(formValues)
  })

  useEffect(() => {
    const savedEmail = window.localStorage.getItem('tabifyRegisterEmail')
    window.localStorage.removeItem('tabifyRegisterEmail')

    if (savedEmail) {
      setFieldValue('email', savedEmail)
    }
  }, [setFieldValue])

  const confirmRegistration = useCallback(async (formValues) => {
    try {
      const response = await axios.post('/auth/confirm-registration', {
        email: formValues?.email || values.email,
        token
      })

      // Store JWT tokens from response headers
      if (response.headers['x-access-token']) {
        window.sessionStorage.setItem('accessToken', response.headers['x-access-token'])
      }
      if (response.headers['x-refresh-token']) {
        window.localStorage.setItem('refreshToken', response.headers['x-refresh-token'])
      }

      // Refresh user data
      await refreshUser()
      setConfirmed('yes')
      setTimeout(() => {
        navigate('/songs')
      }, 3000)
    } catch (err) {
      if (err.response?.status === 400) {
        setErrors(err.response.data)
      } else {
        console.log(err)
        setErrors({ email: 'An error occurred. Please try again.' })
      }
    }
  }, [token, values.email, refreshUser, navigate, setErrors])

  if (confirmed) {
    return (
      <AuthFormContainer>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
          <h2 style={{ color: '#4CAF50', marginBottom: '1rem' }}>Account Verified!</h2>
          <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' }}>
            Welcome to Tabify! Your account has been verified and you're now logged in.
          </p>
          <p style={{ color: '#999', fontSize: '0.9rem' }}>
            Redirecting you to your songs in 3 seconds...
          </p>
        </div>
      </AuthFormContainer>
    )
  }

  return (
    <AuthFormContainer>
      <h2 style={{ marginBottom: '0.5rem' }}>Verify Your Email</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        Please confirm your email address to complete your registration.
      </p>
      <InputGroup>
        <label htmlFor='email'>Email Address:</label>
        <input type='text' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur} />
        {touched.email && errors.email && <FormError>{errors.email}</FormError>}
        <PrimaryButton type='submit' name='Complete Registration' onClick={handleSubmit}>
          Verify Email
        </PrimaryButton>
      </InputGroup>
    </AuthFormContainer>
  )
}

export default ConfirmRegistration
